var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9165 6.91667L21.6878 24.1185C21.5819 25.6012 20.3481 26.75 18.8617 26.75H7.13801C5.65153 26.75 4.41778 25.6012 4.31188 24.1185L3.08317 6.91667M10.1665 12.5833V21.0833M15.8332 12.5833V21.0833M17.2498 6.91667V2.66667C17.2498 1.88426 16.6156 1.25 15.8332 1.25H10.1665C9.3841 1.25 8.74984 1.88426 8.74984 2.66667V6.91667M1.6665 6.91667H24.3332",
    stroke: "#EA4125",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.374884fdd5b22e9e5c02e1e3f748392f.svg";
export { ForwardRef as ReactComponent };